<template>
  <div class="dashboard-main-container">
    <main-header :show-logo="true" :is-active="false" />
    <div v-if="isInitialRoute" class="top-bar"></div>
    <div class="dashboard-content">
      <router-view />
    </div>
  </div>
</template>
<script>
import MainHeader from '@/components/MainHeader'

export default {
  components: {
    MainHeader
  },
  computed: {
    isInitialRoute() {
      return this.$route.name === 'generateLegal'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.dashboard-main-container {
  @media screen {
    height: 100vh;
    overflow: auto;
  }
  flex-grow: 1;
  .top-bar {
    height: 140px;
    width: 100%;
    background: linear-gradient(275.04deg, #ecf5fb -2.88%, #b5d8f0 98.59%);
  }
}

.dashboard-content {
  width: auto;
  height: calc(100vh - 140px);
  margin-left: 108px;
  margin-right: 108px;
  margin-bottom: 40px;
  @media screen and (max-width: $tablet) {
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>
